import React, { useEffect, useState } from "react";
import {observer} from "mobx-react";
import Menu from "../../../@types/stores/menu";
import menuStore from "../../../stores/menu";
import lodash from "lodash";
import {ReactComponent as IconArrow} from "../../../assets/icons/arrow.svg";
import { moveToTop } from "../../../helpers/DomHelper";


const HeaderMenuCategories = () => {

    const [categories, setCategories] = useState<Menu[]>([]);

    useEffect(() => {
        getCategories();

        const itemsDom = document.querySelector(".HeaderMenuCategories .items");
        if (itemsDom)
            itemsDom.addEventListener("scroll", checkOpacity);

        return () => {
            if (itemsDom)
                itemsDom.removeEventListener("scroll", checkOpacity);
        }
    }, []);

    useEffect(() => {
        checkOpacity();
    }, [categories]);

    const getCategories = async () => {
        if (!menuStore.menu)
            await menuStore.getMenu();

        const cats: Menu[] = [];
        menuStore.menu?.forEach(x => {
            const category = lodash.cloneDeep(x);
            delete category.submenu;
            cats.push(category);
        });
        setCategories(cats);
    }

    const changeCategory = (category: Menu) => {
        menuStore.changeCategory(category.id);
        moveToTop();
    }

    const moveNext = () => {
        const itemsDom = document.querySelector(".HeaderMenuCategories .items");

        if (itemsDom) {
            const endScroll = itemsDom.scrollWidth - itemsDom.clientWidth;

            if (itemsDom.scrollLeft < endScroll) {
                const to = itemsDom.scrollLeft + 200 < endScroll ? itemsDom.scrollLeft + 200 : endScroll;
                itemsDom.scrollTo(to , 0);
            }
        }
    }

    const movePrev = () => {
        const itemsDom = document.querySelector(".HeaderMenuCategories .items");

        if (itemsDom) {
            if (itemsDom.scrollLeft > 0) {
                const to = itemsDom.scrollLeft - 200 > 0 ? itemsDom.scrollLeft - 200 : 0;
                itemsDom.scrollTo(to, 0);
            }
        }
    }

    const checkOpacity = () => {
        const itemsDom = document.querySelector(".HeaderMenuCategories .items");
        if (itemsDom) {
            const endScroll = itemsDom.scrollWidth - itemsDom.clientWidth;
            if (endScroll === 0) {
                itemsDom.classList.remove("hasPrev");
                itemsDom.classList.remove("hasPrevNext");
                itemsDom.classList.add("hasNext");

                const prevArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.left");
                if (prevArrowDom)
                    prevArrowDom.classList.add("invisible");

                const nextArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.right");
                if (nextArrowDom)
                    nextArrowDom.classList.add("invisible");
                return;
            }

            if (endScroll === itemsDom.scrollLeft) {
                itemsDom.classList.remove("hasNext");
                itemsDom.classList.remove("hasPrevNext");
                itemsDom.classList.add("hasPrev");

                const nextArrowDom = document.querySelector(".HeaderMenuCategories .arrow.right");
                if (nextArrowDom)
                    nextArrowDom.classList.add("invisible");

                const prevArrowDom = document.querySelector(".HeaderMenuCategories .arrow.left");
                if (prevArrowDom)
                    prevArrowDom.classList.remove("invisible");
            }
            else if (0 === itemsDom.scrollLeft) {
                itemsDom.classList.remove("hasPrev");
                itemsDom.classList.remove("hasPrevNext");
                itemsDom.classList.add("hasNext");

                const prevArrowDom = document.querySelector(".HeaderMenuCategories .arrow.left");
                if (prevArrowDom)
                    prevArrowDom.classList.add("invisible");

                const nextArrowDom = document.querySelector(".HeaderMenuCategories .arrow.right");
                if (nextArrowDom)
                    nextArrowDom.classList.remove("invisible");
            }
            else {
                itemsDom.classList.remove("hasNext");
                itemsDom.classList.remove("hasPrev");

                if (!itemsDom.classList.contains("hasPrevNext"))
                    itemsDom.classList.add("hasPrevNext");


                const nextArrowDom = document.querySelector(".HeaderMenuCategories .arrow.right");
                if (nextArrowDom && nextArrowDom.classList.contains("invisible"))
                    nextArrowDom.classList.remove("invisible");

                const prevArrowDom = document.querySelector(".HeaderMenuCategories .arrow.left");
                if (prevArrowDom && prevArrowDom.classList.contains("invisible"))
                    prevArrowDom.classList.remove("invisible");
            }
        }
    }

    return <div className="HeaderMenuCategories">
        <div className="arrow left invisible" onClick={movePrev}>
            <IconArrow />
        </div>
        <div className="items">
            {categories.filter(x => !x.hidden).map(x => <div key={x.name} className={`item ${x.id === menuStore.navigation.category ? "active" : ""}`} onClick={() => changeCategory(x)}>
                {x.name}
            </div>)}
        </div>
        <div className="arrow right invisible" onClick={moveNext}>
            <IconArrow />
        </div>
    </div>
}

export default observer(HeaderMenuCategories);
